import { stringSchema, objectSchema } from '@/schemas'

export const commentSchema = objectSchema({
  id: stringSchema.optional(),
  body: stringSchema.min(1),
})
